export default __webpack_public_path__ + "static/media/word_icon.495b2665.svg";